// YouTube API
import { getAPI, token } from "@/api/params.js";
import { makeJsonRequest } from "@/api/common.js";
import { getTimestampedUrl } from "../common";
import { getAccounts } from "./socials.js";
import store from "@/store";

// Google OAuth authentication URL
const GOOGLE_API_ENDPOINT = "https://accounts.google.com/gsi/client";
// Google App Client ID
// eslint-disable-next-line no-undef
const GOOGLE_APP_ID = process.env.VUE_APP_GOOGLE_APP_ID;
// Redirect URI (same as site URI)
// eslint-disable-next-line no-undef
const GOOGLE_REDIRECT = process.env.VUE_APP_GOOGLE_REDIRECT_URI;
// Google scopes
const GOOGLE_SCOPES = [
  "https://www.googleapis.com/auth/youtube.upload",
  "https://www.googleapis.com/auth/youtube.readonly",
  "https://www.googleapis.com/auth/youtubepartner",
  "https://www.googleapis.com/auth/youtube",
  "https://www.googleapis.com/auth/youtube.force-ssl"
];

export const YOUTUBE_CATEGORIES = {
  "1": "Film & Animation",
  "2": "Autos & Vehicles",
  "10": "Music",
  "15": "Pets & Animals",
  "17": "Sports",
  "19": "Travel & Events",
  "20": "Gaming",
  "22": "People & Blogs",
  "23": "Comedy",
  "24": "Entertainment",
  "25": "News & Politics",
  "26": "Howto & Style",
  "27": "Education",
  "28": "Science & Technology",
  "29": "Nonprofits & Activism"
};

// Google API prefix
const API_PREFIX = `${getAPI()}/user/socials/google`;

// Google OAuth var
// let auth2 = null;
let client = null;

// API initializing
initGoogleAPI();

/**
 * Connect to service new Google account via OAuth process
 */
export const authYoutube = async () => {
  // const { code } = await auth2.grantOfflineAccess();
  client.requestCode();
};

/**
 * Upload video to YouTube
 * @param {Number} videoId Video ID
 * @param {Number} accountId Internal account ID
 * @param {Object} youtubeData YouTube video metadata: title, description, tags, categoryId, privacyStatus
 */
export const shareToYoutube = async (
  videoId,
  accountId,
  youtubeData,
  multistepId
) => {
  const shareURL = getTimestampedUrl(
    getSharingURL(videoId, accountId, multistepId),
    youtubeData.scheduledTime
  );
  const data = {
    title: youtubeData.title,
    description: youtubeData.description,
    tags: youtubeData.tags,
    categoryId: youtubeData.categoryId,
    privacyStatus: youtubeData.isPublic ? "public" : "private",
    playlistId: youtubeData.playlistId
  };

  await makeJsonRequest({
    url: shareURL,
    method: "POST",
    data: data
  });
};

/**
 * Load Google (YouTube) account email address
 * @param {Object} accountId Internal account ID
 */
export const getGoogleEmail = async accountId => {
  const requestURL = `${API_PREFIX}/${accountId}/tokeninfo?token=${token}`;
  const resp = await fetch(requestURL);
  const info = await resp.json();

  if (resp.ok) {
    // Successful request
    return info.email;
  } else if (resp.status == 400 && info.error == "invalid_token") {
    // Google credentials refreshing is making on server
    console.log("Google refreshing...");
  } else {
    // Some wrong happened
    throw new Error(`${resp.status}: ${resp.statusText}`);
  }
};

export const getYoutubePlaylists = async accountId => {
  const playlistsUrl = `${API_PREFIX}/${accountId}/playlists?token=${token}`;
  const playlistsResp = await fetch(playlistsUrl);
  const { success, data, error } = await playlistsResp.json();

  if (!success) {
    throw new Error(error);
  }

  return data[0].playlists;
};

/**
 * Return Facebook share API URL
 * @param {Number} videoId Internal video ID
 * @param {Number} accountId Internal account ID
 */
function getSharingURL(videoId, accountId, multistepId) {
  if(multistepId === undefined) {
    return `${getAPI()}/video/${videoId}/share/youtube?token=${token}&social=${accountId}`;
  } else {
    return `${getAPI()}/video/${videoId}/share/youtube?token=${token}&social=${accountId}&multistepId=${multistepId}`;
  }
  // return `${getAPI()}/video/${videoId}/share/youtube?token=${token}&social=${accountId}&multistepId=${multistepId}`;
}

/**
 * Initialize Google API
 */
function initGoogleAPI() {
  const googleAPIScript = document.createElement("script");
  googleAPIScript.setAttribute("src", GOOGLE_API_ENDPOINT);
  googleAPIScript.onload = () => {
    // eslint-disable-next-line no-undef
    // gapi.load("auth2", () => {
    //   // eslint-disable-next-line no-undef
    //   auth2 = gapi.auth2.init({
    //     client_id: `${GOOGLE_APP_ID}.apps.googleusercontent.com`,
    //     redirect_uri: `${GOOGLE_REDIRECT}`,
    //     scope: GOOGLE_SCOPES.join(" "),
    //     plugin_name: 'MangomoloVideoEditor'
    //   });
    // });
    // eslint-disable-next-line no-undef
    client = google.accounts.oauth2.initCodeClient({
      client_id: `${GOOGLE_APP_ID}.apps.googleusercontent.com`,
      redirect_uri: `${GOOGLE_REDIRECT}`,
      scope: GOOGLE_SCOPES.join(" "),
      plugin_name: "MangomoloVideoEditor",
      callback: async response => {
        const reqURL = `${API_PREFIX}/connect?token=${token}`;

        await makeJsonRequest({
          url: reqURL,
          method: "POST",
          data: { code: response.code }
        });
        getAccounts();
        store.dispatch("addAccount", "youtube");
      }
    });
  };
  document.head.appendChild(googleAPIScript);
}
